// extracted by mini-css-extract-plugin
export default {"card":"DnDCard_card__ffTDN","button":"DnDCard_button__3KVNb","svg":"DnDCard_svg__Cai-K"};